import { useQuery } from "react-query"
import { listDocs } from "~/actions/docs"

export const useGetDocs = (data) => {
  return useQuery(["docs", data], () => listDocs(data), {
    enabled: !!data,
  })
}
